<template>
    <vx-card title="Редактирование лимита" id="loader">
        <div class="vx-row">
            <div class="vx-col w-1/2">
                <label class="vs-input--label">
                    SSP
                </label>
                <v-select
                    :options="dicts.sspTypes"
                    disabled
                    label="name"
                    placeholder="Выберите SSP"
                    class="w-full"
                    v-model="form.sspTypeId"
                    :reduce="a => a.id"
                    >
                </v-select>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <vs-input
                    label="Количество показов"
                    v-model="form.buyouts"
                    class="mt-1 w-full"
                    type="number"
                    min="0"
                    :danger="!!errors.buyouts"
                    :danger-text="errors.buyouts"
                />
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
    import vSelect from 'vue-select';
    import axios from 'axios';

    export default {
        name: 'ml-threshold-push-edit',   
        props: ['id'],
        data() {
            return {
                item: undefined,
                dicts: {
                    sspTypes: []
                },
                form: {
                    sspTypeId: undefined,
                    buyouts: undefined
                },
                errors: {
                    sspTypeId: '',
                    buyouts: ''
                }
            }
        },
        components: {
            'v-select': vSelect
        },
        methods: {
            loadDicts() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.axios.get('ml-threshold/push/dicts')
                    .then((resp) => {
                        this.dicts.sspTypes = resp.data.sspTypes;
                    })
                    .catch((err) => {
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка загрузки справочников.",
                            color: "danger",
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                    });
            },
            loadData() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.axios.get('ml-threshold/push/' + this.id)
                    .then((item) => {
                        this.item = item.data;
                        this.form.sspTypeId = item.data.sspTypeId;
                        this.form.buyouts = item.data.buyouts;
                    })
                    .catch((err) => {
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка загрузки данных.",
                            color: "danger",
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                    });
            },
            save() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                const params = {
                    id: this.id,
                    buyouts: this.form.buyouts
                };
                this.$axios({
                    method: 'PUT',
                    url: 'ml-threshold/push/' + this.id,
                    params: params,
                    errors: this.errors,
                    success: (user) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Лимит успешно обновлен",
                            color: "success",
                        });
                        this.$router.push('/ml-threshold-push');
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        if (err.request.status == 422 && err.data.errors['']) {
                        const error = err.data.errors[''][0];
                            return this.$vs.notify({
                                title: 'Внимание!',
                                text: error,
                                color: 'danger',
                                time: 8000
                            });
                        } else {
                            this.$vs.notify({
                                title: 'Внимание!',
                                text: 'Ошибка сервера',
                                color: 'danger'
                            });
                        }
                    }
                })
            },
            cancelEdit() {
                this.$router.push('/ml-threshold-push');
            }
        },
        mounted() {
            this.loadDicts();
            this.loadData();
        }
    }
</script>

<style>
    .select-error > div {
        border: 1px solid rgba(var(--vs-danger),1)!important;
    }
</style>